import React from 'react';

import { type DetailsPageRightSidebarProps } from 'app/main/components/page-layouts';

import MarketingActionsDetailsSectionStats from './sidebar/MarketingActionsDetailsSectionStats';
import MarketingActionsDetailsSectionMap from './sidebar/MarketingActionsDetailsSectionMap';

export default function MarketingActionsDetailsRightSidebar(props: DetailsPageRightSidebarProps) {
	const sections: React.ReactNode[] = [];

	if (!props.isAdd) {
		if (props.model.maac_stats) {
			sections.push(<MarketingActionsDetailsSectionStats stats={props.model.maac_stats} />);
		}
		if (props.model.maac_uid) {
			sections.push(<MarketingActionsDetailsSectionMap maacUid={props.model.maac_uid} />);
		}
	}

	return sections;
}
